import { getAmplitudeInstance } from '../amplitudeHelpers';
import WebHeaderUpgradeToProCopyText from '../enums/WebHeaderUpgradeToProCopyText';

type logWebHeaderUpgradeToProTappedParams = {
  copy_text?: WebHeaderUpgradeToProCopyText;
};

/**
 * The 'Upgrade to Pro' CTA is tapped in the global header on web. This is only visible to logged in free users
 * @param params - Attributes to log with the amplitude event
 * @param params.copy_text - [Web Only] The text copy used on the Web Header Upgrade To Pro CTA button.
 */
const logWebHeaderUpgradeToProTapped = ({ copy_text }: logWebHeaderUpgradeToProTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('web header upgrade to pro tapped', { 'copy text': copy_text }, callback);
};

export default logWebHeaderUpgradeToProTapped;
